module.exports = __webpack_public_path__ + "static/media/banner-e4.de41204c.jpg";